import { render, staticRenderFns } from "./EditIpWhitelist.vue?vue&type=template&id=0e8bc1d3&scoped=true&"
import script from "./EditIpWhitelist.vue?vue&type=script&lang=ts&"
export * from "./EditIpWhitelist.vue?vue&type=script&lang=ts&"
import style0 from "./EditIpWhitelist.vue?vue&type=style&index=0&id=0e8bc1d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8bc1d3",
  null
  
)

export default component.exports